import { IrPortfolioPerformanceDTO } from "../../../../../pojo/ir-common-classes";

export class IrPortfoliosSummaryTable {
  active: IrPortfolioPerformanceDTO[] = [];
  realized: IrPortfolioPerformanceDTO[] = [];
  total = {
    active: new IrPortfolioPerformanceDTO(),
    realized: new IrPortfolioPerformanceDTO(),
  };

  grandTotal = new IrPortfolioPerformanceDTO();
}

export class IrSummaryTableShowSettings {
  activePP = true;
  realizedPP = true;
}

export class IrSummaryTableToolTipSettings {
  showTooltip = false;
  tooltipText = '';
  tooltipCoordinates?: DOMRect;
}

export class IrCheckboxPortfolioStatus {
  selectedIds = new Set<number>();
  activeCheckboxStatus = IrSummaryTableCheckboxStatus.Empty;
  realizedCheckboxStatus = IrSummaryTableCheckboxStatus.Empty;
}

export class IrSummaryTableIsAllPPsSelected {
  active = false;
  realized = false;
}

export enum IrSummaryTableCheckboxStatus {
  Checked = 'checked',
  Minus = 'minus',
  Empty = 'empty'
}


export enum IrPortfolioSortingEnum {
  BY_COMPANY = 'Company',
  BY_COUNTRY = 'Country',
  BY_INDUSTRY = 'Industry',
  BY_GROUP = 'Group',
  BY_DATE_OF_INITIAL_INV = 'Initial inv. date',
  BY_COST = 'Investment',
  BY_FAIRVALUE = 'Fair value',
  BY_GAIN = 'Gain/(loss)',
  BY_HOLDING = 'Holding',
  BY_MOIC = 'MOIC',
  BY_IRR = 'IRR',
  BY_TOTAL_INV = 'Total raised',
  BY_VALUATION_ROUND_VALUE = 'Company valuation',
}

export enum IrPortfolioSortingOrderEnum {
  ASC = 'Low to high',
  DES = 'High to low'
}
